import { useMemo } from "react";
import { useTheme } from "next-themes";

export interface ChartColors {
  deposit: string;
  withdrawal: string;
  grid: string;
  axis: string;
  tooltipBg: string;
  tooltipBorder: string;
}

const LIGHT_CHART: ChartColors = {
  deposit: "hsl(234, 91%, 54%)",
  withdrawal: "hsl(25, 95%, 53%)",
  grid: "hsl(220, 13%, 91%)",
  axis: "hsl(215, 16%, 47%)",
  tooltipBg: "hsl(0, 0%, 100%)",
  tooltipBorder: "hsl(220, 13%, 91%)",
};

const DARK_CHART: ChartColors = {
  deposit: "hsl(190, 100%, 50%)",
  withdrawal: "hsl(25, 95%, 53%)",
  grid: "hsl(230, 30%, 20%)",
  axis: "hsl(215, 20%, 65%)",
  tooltipBg: "hsl(230, 40%, 14%)",
  tooltipBorder: "hsl(230, 30%, 20%)",
};

/** Theme-aware palette for Recharts on Bridge Statistics. */
export function useChartColors(): ChartColors {
  const { resolvedTheme } = useTheme();

  return useMemo(
    () => (resolvedTheme === "light" ? LIGHT_CHART : DARK_CHART),
    [resolvedTheme]
  );
}
